module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (123).643782c0.jpg";